import React from "react";
import { Box, ButtonBase, Card, CardContent, Typography } from "@mui/material";
import { ORDER_COLORS } from "../../../Components/Orders/OrderCardParts";

export interface OrderStatusItem {
  label: string;
  value: number;
  color: string;
  onClick: () => void;
}

interface LabOrderStatusCardProps {
  totalOrders: number;
  items: OrderStatusItem[];
}

// One card holding the order status breakdown; each status opens its filtered order list
const LabOrderStatusCard: React.FC<LabOrderStatusCardProps> = ({ totalOrders, items }) => (
  <Card sx={{ borderRadius: "16px", boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.05)", height: "100%" }}>
    <CardContent sx={{ pb: "16px !important", height: "100%", display: "flex", flexDirection: "column" }}>
      <Typography variant="subtitle2" color="text.secondary">
        Order status
      </Typography>
      <Typography sx={{ color: ORDER_COLORS.muted, fontSize: "0.75rem", mb: 1.5 }}>
        Out of {totalOrders} {totalOrders === 1 ? "order" : "orders"}
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(4, 1fr)" },
          gap: 1,
          flexGrow: 1,
        }}
      >
        {items.map((item) => (
          <ButtonBase
            key={item.label}
            onClick={item.onClick}
            aria-label={`${item.label}: ${item.value}`}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 0.5,
              p: 1.5,
              borderRadius: "12px",
              border: `1px solid ${ORDER_COLORS.border}`,
              textAlign: "left",
              transition: "background-color 0.2s, border-color 0.2s",
              "&:hover": { bgcolor: ORDER_COLORS.light, borderColor: ORDER_COLORS.primary },
              "&.Mui-focusVisible": { outline: `2px solid ${ORDER_COLORS.primary}`, outlineOffset: 2 },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
              <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: item.color, flexShrink: 0 }} />
              <Typography sx={{ color: "text.secondary", fontSize: "0.8rem" }}>{item.label}</Typography>
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: "1.5rem", color: ORDER_COLORS.dark, lineHeight: 1.2 }}>
              {item.value}
            </Typography>
          </ButtonBase>
        ))}
      </Box>
    </CardContent>
  </Card>
);

export default LabOrderStatusCard;
